/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.gaiaFooter[_ngcontent-%COMP%] {position:relative; bottom:0px; display: block; height:100%}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL2luY2x1ZGUvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL2luY2x1ZGUvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/$$_gendir/app/include/footer/footer.component.css.shim.ngstyle.ts